/** Staging D1 checkout client — CLOUDFLARE-D1-070 / M71. No secrets. */

const API_BASE = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") ?? "";

export function isD1CheckoutEnabled(): boolean {
  const raw = import.meta.env.VITE_MINIAPP_D1_CHECKOUT_ENABLED;
  if (typeof raw !== "string") return false;
  const v = raw.trim().toLowerCase();
  return v === "1" || v === "true" || v === "yes";
}

function url(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return API_BASE ? `${API_BASE}${p}` : p;
}

async function postJson(path: string, body: Record<string, unknown>) {
  const response = await fetch(url(path), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const json = (await response.json()) as Record<string, unknown>;
  return { status: response.status, json };
}

async function getJson(path: string) {
  const response = await fetch(url(path), {
    method: "GET",
    headers: { Accept: "application/json" },
  });
  const json = (await response.json()) as Record<string, unknown>;
  return { status: response.status, json };
}

export async function d1CreateCartDraft(input: {
  sessionKey: string;
  items: Array<{
    product_id: string;
    title: string;
    qty: number;
    unit_price_uah?: number | null;
    price_resolved?: boolean;
    stock_status?: string | null;
  }>;
  catalogMode?: string;
}) {
  return postJson("/api/miniapp/cart/draft", {
    session_key: input.sessionKey,
    items: input.items,
    catalog_mode: input.catalogMode ?? "live",
  });
}

export async function d1CreateCheckoutDraft(input: {
  sessionKey: string;
  cartId: string;
  contactName?: string;
  contactPhone?: string;
  couponCode?: string;
  catalogMode?: string;
}) {
  return postJson("/api/miniapp/checkout/draft", {
    session_key: input.sessionKey,
    cart_id: input.cartId,
    contact_name: input.contactName,
    contact_phone: input.contactPhone,
    coupon_code: input.couponCode,
    catalog_mode: input.catalogMode ?? "live",
    delivery_method: "nova_poshta_warehouse",
    payment_method: "pending_manual",
  });
}

export async function d1ClaimTg50(sessionKey: string, contactPhone?: string) {
  return postJson("/api/miniapp/coupons/tg50/claim", {
    session_key: sessionKey,
    contact_phone: contactPhone,
  });
}

export async function d1PlaceOrder(input: {
  sessionKey: string;
  draftId: string;
  idempotencyKey: string;
  catalogMode?: string;
}) {
  return postJson("/api/miniapp/orders/place", {
    session_key: input.sessionKey,
    draft_id: input.draftId,
    idempotency_key: input.idempotencyKey,
    catalog_mode: input.catalogMode ?? "live",
  });
}

export async function d1GetOrderStatus(orderId: string) {
  return getJson(`/api/miniapp/orders/${encodeURIComponent(orderId)}/status`);
}

/** Customer status copy keys from M71 ops bridge (display only). */
export const CUSTOMER_STATUS_COPY_UK: Record<string, string> = {
  payment_pending: "Очікуємо оплату. Після підтвердження підготуємо відправлення.",
  payment_under_review: "Оплату перевіряє менеджер. Це займе трохи часу.",
  payment_confirmed: "Оплату підтверджено вручну. Готуємо відправлення (без live-платежу).",
  np_details_needed: "Потрібні дані Нової Пошти: місто та відділення. Live ТТН не створюється.",
  preparing_shipment: "Замовлення готується до відправки.",
  shipped_manually: "Відправлено вручну. Live ТТН не генерується на цьому етапі.",
  support_contact: "Якщо потрібна допомога — напишіть у підтримку AsiaStyle.",
  payment_rejected: "Оплату не підтверджено. Зв’яжіться з підтримкою або повторіть оплату.",
  payment_refund_needed: "Потрібне повернення — менеджер опрацьовує запит.",
};
